import styled, { css } from 'styled-components';
import { media } from 'utils/detection';

export default styled.p`
  flex: 1;
  color: ${props => props.theme.textSemiDark};
  font-family: 'Galano Classic';
  font-size: 7px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1.18px;
  padding: 0;
  margin: 0;

  ${media.medium`
    color: ${props => props.theme.textLightGreen};
    font-size: 1.2vw;
    line-height: 2.54vw;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.14vw;
    cursor: pointer;
    transition-property: color;
    transition-duration: 0.3s;
    transition-timing-function: ease;

    ${props =>
      props.isMouseOverRole &&
      css`
        color: ${props.theme.textSemiDark};
        font-weight: 700;
      `}
 `}

  ${media.large`
    font-size: 0.8vw;
 `}
`;
